export interface JwtPayload {
  act: string;
  exp: number;
  iat: number;
  iss: string;
  sub: string;
  suid: string;
  userType: 'AGENT' | 'EMPLOYEE' | 'GUEST' | 'OWNER' | 'SERVICE_PROVIDER_USER';
  userUid: string;
}

export const debounce =
  (callback: (...args: any[]) => void, time: number = 250, interval?: any) =>
  // @ts-expect-error TS7019 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  (...args) => {
    clearTimeout(interval);
    interval = setTimeout(() => callback(...args), time);
  };

export const convertToBase64 = (file: File) => {
  if (!file) return Promise.resolve('');

  return new Promise<string>((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);

    fileReader.onload = () => {
      resolve(fileReader.result as string);
    };

    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

/**
 * Object.entries alternative that supports type inference.
 */
export const typedEntries = <T extends object>(
  obj: T,
): [keyof T, T[keyof T]][] => {
  return Object.entries(obj) as [keyof T, T[keyof T]][];
};

export const parseJwt = (token: string): JwtPayload => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map((c) => {
        return `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`;
      })
      .join(''),
  );

  return JSON.parse(jsonPayload);
};
